// src/resources/rdf/RejectButton.js
import * as React from "react";
import { useRecordContext } from "react-admin";
import {
    Button,
    Box,
    Tooltip,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import BlockIcon from "@mui/icons-material/Block";
import { adminPatch } from "../../config/api";
import useModerationAction from "../../hooks/useModerationAction";

export default function RejectButton() {
    const record = useRecordContext();
    const { loading, run } = useModerationAction();
    const [open, setOpen] = React.useState(false);
    const [reason, setReason] = React.useState("");

    // Déjà rejeté -> pas de bouton
    if (!record || record.status === "REJECTED") return null;

    const submit = async (event) => {
        event?.stopPropagation?.();
        await run({
            id: record.id,
            request: () => adminPatch(`/rdf/${record.id}/reject`, { reason: reason || null }),
            successMessage: "RDF rejeté",
            onSuccess: () => {
                setOpen(false);
                setReason("");
            },
        });
    };

    return (
        <>
            <Tooltip title="Rejeter ce RDF">
                {/* wrapper pour conserver le tooltip si disabled */}
                <span>
          <Button
              onClick={(event) => {
                  event?.stopPropagation?.();
                  setOpen(true);
              }}
              disabled={loading}
              variant="contained"
              aria-label="Rejeter ce RDF"
              sx={{
                  bgcolor: "#d32f2f",
                  color: "white",
                  borderRadius: "20px",
                  textTransform: "none",
                  px: 2,
                  py: 0.5,
                  fontWeight: "bold",
                  ml: 1,
                  "&:hover": { bgcolor: "#b71c1c" },
              }}
              startIcon={
                  loading ? <CircularProgress size={16} sx={{ color: "white" }} /> : null
              }
          >
            Rejeter
            <Box
                sx={{
                    ml: 1,
                    bgcolor: "white",
                    color: "#d32f2f",
                    borderRadius: "50%",
                    width: 20,
                    height: 20,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: "0.9rem",
                    fontWeight: "bold",
                    border: "1px solid #d32f2f",
                }}
            >
              <BlockIcon sx={{ fontSize: 14 }} />
            </Box>
          </Button>
        </span>
            </Tooltip>

            <Dialog open={open} onClose={() => !loading && setOpen(false)} maxWidth="sm" fullWidth>
                <DialogTitle>Confirmer le rejet</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Motif (optionnel)"
                        fullWidth
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)} disabled={loading}>Annuler</Button>
                    <Button
                        onClick={submit}
                        disabled={loading}
                        variant="contained"
                        sx={{ bgcolor: "#d32f2f", "&:hover": { bgcolor: "#b71c1c" } }}
                    >
                        {loading ? <CircularProgress size={16} sx={{ color: "white" }} /> : "Confirmer le rejet"}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
